import { v4 as uuidv4 } from "uuid";
import { NetworkError } from "@/interfaces/errors/networkError";

const prismeApiUrl = process.env.NEXT_PUBLIC_PRISME_API_URL ?? "";

export type Reservation = {
  id: string;
  price: number;
  categoryChoice: {
    name: string;
    images: string[];
    prices: {
      price: number;
      currency: string;
      priceType: string;
      promoCodeApplied: boolean;
    }[];
    reference: string;
    seatNumber: number;
    termsOfuse: {
      damageFranchise: number;
      guaranteeDeposit: number;
      additionalKmPrice: number;
      additionalDayPrice: number;
      fireTheftFranchise: number;
    };
    description: string;
    gearboxTypeLabel: string;
    motorizationTypeLabel: string;
  };
  optionsChoices: {
    description: string;
    id: string;
    invoiceDuration: number;
    maxQuantity: number;
    price: number;
    quantity: number;
    title: string;
    unitPrice: number;
  }[];
  insuranceChoice?: {
    id: string;
    price: number;
    title: string;
    unitPrice: number;
    description: string;
    franchiseAmount: number;
    invoiceDuration: number;
  };
  user: {
    mail: string;
    phone: {
      code: string;
      countryCode: string;
      nationalNumber: string;
    };
    partyId: string;
    civility: string;
    lastName: string;
    firstName: string;
  };
  insurances: {
    id: string;
    price: number;
    title: string;
    unitPrice: number;
    description: string;
    franchiseAmount: number;
    invoiceDuration: number;
  }[];
  bookingId: string;
  amountPaid: number;
  transactionId: string;
  expiryDate: string;
  travel: {
    startAgency: {
      id: number;
      name: string;
      payType: string;
      paymentCustomerId: string;
    };
    endAgency: {
      id: number;
      name: string;
      payType: string;
      paymentCustomerId: string;
    };
    startDate: string;
    endDate: string;
    kilometer: number;
    locationDays: number;
    vehicleType: string;
    bffCubeId: string;
  };
};

export type ReservationsResponse = {
  status: number;
  data: Reservation[];
};

export const sendFetchUserReservations = (accessToken?: string) => {
  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.append("x-request-id", uuidv4());

  if (accessToken !== undefined) {
    requestHeaders.append("Authorization", `Bearer ${accessToken}`);
    requestHeaders.append("Accept", "/");
  }

  return fetch(`${prismeApiUrl}/user/reservations`, {
    method: "GET",
    headers: requestHeaders,
  }).then((response) => {
    if (!response.ok) {
      throw new NetworkError(
        `Request returned error ${response.status}`,
        response.status
      );
    }

    const contentType = response.headers.get("content-type");

    if (contentType?.includes("application/json")) {
      return response.json();
    } else {
      // calling response.json() with empty response body would throw
      return Promise.resolve({});
    }
  });
};
